const CheckSquareIcon = ({ className, fill }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M28.8534 3.21867C26.6151 2.917 23.7468 2.91699 20.0951 2.91699H19.9051C16.2534 2.91699 13.3851 2.917 11.1467 3.21867C8.85173 3.527 7.03177 4.17197 5.60177 5.60197C4.17177 7.03197 3.52676 8.85197 3.21842 11.147C2.91676 13.3853 2.91675 16.2537 2.91675 19.9054V20.0953C2.91675 23.747 2.91676 26.6153 3.21842 28.8537C3.52676 31.1487 4.17177 32.9687 5.60177 34.3987C7.03177 35.8287 8.85173 36.4736 11.1467 36.782C13.3851 37.0836 16.2534 37.0837 19.9051 37.0837H20.0951C23.7468 37.0837 26.6151 37.0836 28.8534 36.782C31.1484 36.4736 32.9684 35.8287 34.3984 34.3987C35.8284 32.9687 36.4734 31.1487 36.7817 28.8537C37.0834 26.6153 37.0834 23.747 37.0834 20.0953V19.9054C37.0834 16.2537 37.0834 13.3853 36.7817 11.147C36.4734 8.85197 35.8284 7.03197 34.3984 5.60197C32.9684 4.17197 31.1484 3.527 28.8534 3.21867Z"
        fill={fill || "#0051FF"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1147 4.59514C36.7997 5.21014 36.8547 6.2635 36.2397 6.9485L21.238 23.6152C20.933 23.9552 20.5014 24.1535 20.043 24.1668C19.5864 24.1785 19.1447 24.0018 18.8214 23.6785L12.988 17.8451C12.3364 17.1951 12.3364 16.1385 12.988 15.4885C13.638 14.8369 14.6947 14.8369 15.3447 15.4885L19.9364 20.0802L33.7614 4.71852C34.3764 4.03518 35.4314 3.97848 36.1147 4.59514Z"
        fill={fill || "#0051FF"}
      />
    </svg>
  );
};

export default CheckSquareIcon;
